import { useMemo } from 'react';
import { ContactSupportProps } from '../contact-support.types';

const normalizeBreaks = (v?: string): string => (typeof v === 'string' ? v.replace(/<br\s*\/?>/gi, '\n') : '');

function addBreaksToText(text?: string): string {
  if (!text || typeof text !== 'string') return '';
  // Add breaks after question marks followed by space and capital letter
  return text.replace(/\?\s+([A-Z])/g, '?<br>$1');
}

export function useContactSupport(props: ContactSupportProps) {
  const resolvedHeadingText = props.heading;

  const headingWithBreaks = useMemo(() => {
    return normalizeBreaks(addBreaksToText(resolvedHeadingText));
  }, [resolvedHeadingText]);

  return {
    headingWithBreaks,
  };
}
